import "./Loader.css";

export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-ring"></div>
    </div>
  );
};
